var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoreAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h28v28H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.99 4.93c-.69-.64-1.5-1.13-2.39-1.45a7.309 7.309 0 0 0-5.21 0c-.89.32-1.7.81-2.39 1.45a7.412 7.412 0 0 0-2.39 5.63c.06 1.85.7 3.63 1.82 5.1 1.57 2.09 3.44 3.92 5.56 5.44 2.12-1.52 3.99-3.36 5.56-5.44a8.8 8.8 0 0 0 1.82-5.07c.06-2.14-.81-4.21-2.39-5.66Zm-.13 10.16A24.964 24.964 0 0 1 14 19.97a24.427 24.427 0 0 1-4.86-4.88 7.843 7.843 0 0 1-1.65-4.53c-.03-1.07.2-2.14.67-3.1.4-.79.96-1.49 1.65-2.05a6.54 6.54 0 0 1 2.13-1.14c.67-.23 1.37-.35 2.07-.36.71.01 1.41.13 2.08.36.77.25 1.48.64 2.11 1.14.69.56 1.25 1.26 1.65 2.05.47.96.7 2.03.67 3.1a7.843 7.843 0 0 1-1.65 4.53Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12c.43.01.85-.16 1.14-.48.29-.31.46-.72.45-1.14 0-.88-.71-1.59-1.59-1.59-.88 0-1.59.71-1.59 1.59 0 .43.16.84.46 1.14.29.31.7.48 1.13.48ZM6.62 24.1h14.76v.9H6.62z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreAddress);
export default __webpack_public_path__ + "static/media/Store Address.43c24e904fe1c91cf70a1412d3f7ef96.svg";
export { ForwardRef as ReactComponent };